module.exports = __webpack_public_path__ + "static/key-boundless-ebb6f66445ff7c26016b4fe1c1821568.webp";